import Footer from "./components/footer/Footer";
import Header from "./components/header/Header";
import Main from "./components/main/Main";



function App() {

  return (
    <>
      <Header />
      <Main />
      <Footer />
    </>
  );
}

export default App;
